function NoAccessPage({ user }) {
  return (
    <div className="crm-panel mx-auto max-w-xl p-8 text-center">
      <h2 className="text-xl font-semibold text-[rgb(var(--crm-text))]">No sections assigned</h2>
      <p className="crm-text-muted mt-3 text-sm leading-relaxed">
        Your account ({user?.email || 'staff user'}) does not have access to any CRM sections yet.
      </p>
      <p className="crm-text-muted mt-3 text-sm leading-relaxed">
        Ask your admin to open Settings → Assign User, edit your login, and select at least one
        section (for example Procurement or Orders).
      </p>
    </div>
  );
}

export default NoAccessPage;
